// useAuthCTA — F8.7b · unified CTA handler.
//
// When DIRECT_AUTH_ENABLED (kill-switch or ?force_direct_auth=1 in dev):
//   → open the in-app AuthModal
// When disabled (legacy path, before Deploy 6 flip):
//   → redirect to Emergent Auth as fallback
//
// Consumers should call `authCTA.login()` / `authCTA.signup()` /
// `authCTA.googleLogin()` from any LandingV2 CTA.
import { useCallback } from "react";
import { useAuthModal } from "@/context/AuthModalContext";
import useDirectAuthEnabled from "@/hooks/useDirectAuthEnabled";

function emergentRedirect() {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const redirect = encodeURIComponent(`${origin}/profile`);
    window.location.href = `https://auth.emergentagent.com/?redirect=${redirect}`;
}

export default function useAuthCTA() {
    const { openModal } = useAuthModal();
    const { enabled: directAuthEnabled } = useDirectAuthEnabled();

    const login = useCallback((opts = {}) => {
        if (directAuthEnabled) openModal("login", opts);
        else emergentRedirect();
    }, [directAuthEnabled, openModal]);

    const signup = useCallback((opts = {}) => {
        if (directAuthEnabled) openModal("signup", opts);
        else emergentRedirect();
    }, [directAuthEnabled, openModal]);

    const forgot = useCallback((opts = {}) => {
        if (directAuthEnabled) openModal("forgot", opts);
        else emergentRedirect();
    }, [directAuthEnabled, openModal]);

    const googleLogin = useCallback(() => {
        if (directAuthEnabled) {
            const base = process.env.REACT_APP_BACKEND_URL || "";
            window.location.href = `${base}/api/auth/google/login`;
        } else {
            emergentRedirect();
        }
    }, [directAuthEnabled]);

    return { login, signup, forgot, googleLogin, directAuthEnabled };
}
